import AOHeaderPaxSelectorInput from '@atomic/organisms/_common/header/header-pax-selector-input';
import {
  parameters,
  stripTags,
  sendGoogleEvent,
  ucfirst,
  sendRequest,
  getCookie,
  setCookie,
  checkString,
  libInit,
  byUserInteraction,
  setIntersectionObserver,
  appendCurrentDomainPrefix,
  getBreakpointMinWidth,
} from './utils';

import { travellerEnquiryStore } from './footer_script';

const navigation = {
  mainButtonSelector: '.js-ao-header-navigation-mobile__main-button',
  lighthouseMainButtonSelector: '.js-ao-header-navigation__main-button',
  contactButtonSelector: '.js-contact-flow-link',
  searchButtonSelector: '.js-ao-header-navigation-mobile__search-icon',
  existingBookingSelector: '.js-ao-clp-columns__link[href="#existing-booking"]',
  headerPaxSelectorButtonSelector: '.js-ao-header-pax-selector__main-input',
  headerNavigation: false,
  headerPaxSelector: false,
};

const initiateHeaderNavigation = (event, callback) => {
  import(/* webpackChunkName: "HeaderNavigation" */'@atomic/organisms/_common/navigation/script').then((module) => {
    const HeaderNavigation = module.default;
    if (!navigation.headerNavigation) {
      navigation.headerNavigation = new HeaderNavigation();
      navigation.headerNavigation.initiate();
    }
    if (callback) {
      navigation.headerNavigation[callback](event);
    }
  });
};

const initiateHeaderPaxSelector = (event, callback) => {
  if (!navigation.headerPaxSelector) {
    import(/* webpackChunkName: "HeaderPaxSelector" */'@atomic/organisms/_common/header/header-pax-selector').then((module) => {
      const AOHeaderPaxSelector = module.default;
      navigation.headerPaxSelector = new AOHeaderPaxSelector();
      navigation.headerPaxSelector.initiate();
      if (callback) {
        navigation.headerPaxSelector[callback](event);
      }
    });
  }
};

export const navigationInitiate = () => {
  // For Desktop
  byUserInteraction('load-header-navigation', initiateHeaderNavigation);

  // For Mobile
  $('body')
    .on('click', navigation.mainButtonSelector, (event) => initiateHeaderNavigation(event, 'handleMainButtonClick'))
    .on('click', navigation.contactButtonSelector, (event) => initiateHeaderNavigation(event, 'handleContactButtonClick'))
    .on('click', navigation.searchButtonSelector, (event) => initiateHeaderNavigation(event, 'handleSearchButtonClick'))
    .on('click', navigation.existingBookingSelector, (event) => initiateHeaderNavigation(event, 'handleExistingBookingClick'));
};

export const headerPaxSelectorInitiate = () => {
  const MOBILE_WIDTH = getBreakpointMinWidth('m2') - 1;
  const headerPaxSelectorInput = new AOHeaderPaxSelectorInput();
  headerPaxSelectorInput.initiate();

  if ($(window).width() <= MOBILE_WIDTH) {
    $('body')
      .on('click', navigation.headerPaxSelectorButtonSelector, (event) => initiateHeaderPaxSelector(event, 'handleMainButtonClick'));
  } else {
    byUserInteraction('load-header-pax-selector', initiateHeaderPaxSelector);
  }
};

const initiateLighthouseHeaderNavigation = (event, callback) => {
  import('@atomic/organisms/_common/navigation/lighthouse/script').then((module) => {
    const LighthouseHeaderNavigation = module.default;
    if (!navigation.headerNavigation) {
      navigation.headerNavigation = new LighthouseHeaderNavigation();
      navigation.headerNavigation.initiate();
    }
    if (callback) {
      navigation.headerNavigation[callback](event);
    }
  });
};

export const lighthouseNavigationInitiate = () => {
  $('body')
    .on('click', navigation.lighthouseMainButtonSelector, (event) => initiateLighthouseHeaderNavigation(event, 'handleMainButtonClick'));
};

const search = {
  initiated: false,
  clicked: false,
  maxResults: 3,
  groups: {
    places: {
      title: '',
      data: [],
    },
    tours: {
      title: '',
      data: [],
    },
    types: {
      title: '',
      data: [],
    },
    operators: {
      title: '',
      data: [],
    },
    // not displayed due to missing property in groupingOrder
    default: {
      title: '',
      data: [],
    },
  },
  groupingOrder: ['places', 'tours', 'types', 'operators'],
};

export const searchGetSortedResultsByScore = (results) => {
  const tinyAutocompleteData = [];
  for (let i = 0; i < search.groupingOrder.length; i += 1) {
    const groupKey = search.groupingOrder[i];
    const group = results[groupKey];

    if (group && group.data.length) {
      const groupScore = group.score / group.data.length;

      if (tinyAutocompleteData.length) {
        for (let j = 0; j < tinyAutocompleteData.length; j += 1) {
          const sortedGroupScore = tinyAutocompleteData[j].score
              / tinyAutocompleteData[j].data.length;
          if (groupScore > sortedGroupScore) {
            tinyAutocompleteData.splice(j, 0, group);

            break;
          }

          if (j === tinyAutocompleteData.length - 1) {
            tinyAutocompleteData.push(group);

            break;
          }
        }
      } else {
        tinyAutocompleteData.push(group);
      }
    }
  }

  return tinyAutocompleteData;
};

export const searchCalculateHitScore = (group, hit, query) => {
  let score = group.score || 0;
  const hitName = hit.name.toLowerCase();
  const searchQuery = query.toLowerCase();

  // score represents how much of the hit is matched with the query
  if (hitName.indexOf(searchQuery) >= 0) {
    score += Math.round((searchQuery.length / hitName.length) * 100);
  }

  return score;
};

export const searchRedirectToResultsPage = () => {
  const text = $('header input.focus').val();
  const searchResultUrl = $('header input').data('search-result-url');

  window.location.href = `${searchResultUrl}?q=${text}`;
};

export const searchParseResults = (json, searchQuery) => {
  const data = JSON.parse(JSON.stringify(search.groups));

  for (let i = 0; i < json.results.length; i += 1) {
    const { hits } = json.results[i];

    for (let j = 0; j < hits.length; j += 1) {
      let type = 'MIX';
      let eventType = 'MIX';
      let key = 'default';
      const currentHit = hits[j];

      if (currentHit.type_name) {
        eventType = currentHit.type_name;
        type = eventType;
        key = 'tours';
        if (currentHit.type_name === 'Type') {
          key = 'types';
        } else {
          key = 'places';
        }
      } else if (
        json.results[i].index === window.trConfig.algolia.indexes.operators
      ) {
        eventType = 'Operator';
        type = eventType;
        key = 'operators';
      } else if (
        json.results[i].index === window.trConfig.algolia.indexes.tours
      ) {
        eventType = 'Tour';
        type = currentHit.operator_name;
        key = 'tours';
      }

      const group = data[key];
      group.score = searchCalculateHitScore(
        group,
        currentHit,
        searchQuery,
      );

      group.data.push({
        title: currentHit.name,
        url: currentHit.url,
        urlAlternative: currentHit.url_alternative || '',
        type,
        eventType,
      });
    }
  }

  return searchGetSortedResultsByScore(data);
};

export const searchInitiate = () => {
  const $searchInput = $('header input');

  Object.keys(search.groups).forEach((key) => {
    search.groups[key].title = $searchInput.data(`title-${key}`);
  });
  const seeAllText = $searchInput.data('see-all');

  $searchInput
    .one('focus click keydown input', (e) => {
      e.stopPropagation();
      const $currentInput = $(e.currentTarget);

      if (search.initiated) {
        return;
      }
      search.initiated = true;

      libInit('autocomplete', () => {
        $currentInput
          .tinyAutocomplete({
            url: 'https://3VPAXN8SSR-dsn.algolia.net/1/indexes/*/queries',
            method: 'post',
            grouped: true,
            getRequestData: (query) => {
              const params = {
                query,
                attributesToRetrieve:
                        'name,type_name,operator_name,url,url_alternative',
                attributesToHighlight: '',
                hitsPerPage: search.maxResults,
              };

              const requestData = {
                requests: [
                  {
                    indexName: window.trConfig.algolia.indexes.serp,
                    params: $.param(params),
                  },
                  {
                    indexName: window.trConfig.algolia.indexes.operators,
                    params: $.param(params),
                  },
                  {
                    indexName: window.trConfig.algolia.indexes.tours,
                    params: $.param({
                      ...params,
                      // eslint-disable-next-line
                          filters: window.trConfig.customization?.is_shop
                        ? 'active_shop = 1'
                        : 'active_marketplace = 1',
                    }),
                  },
                ],
              };

              return JSON.stringify(requestData);
            },
            ajaxSettings: {
              type: 'post',
              contentType: 'application/json',
              dataType: 'json',
              beforeSend: (xhr) => {
                xhr.setRequestHeader(
                  'X-Algolia-API-Key',
                  window.trConfig.algolia.api_key,
                );
                xhr.setRequestHeader(
                  'X-Algolia-Application-Id',
                  window.trConfig.algolia.app_id,
                );
              },
            },
            wrapField: false,
            itemTemplate:
                    '<li class="autocomplete-item" data-url="{{url}}" data-url-alternative="{{urlAlternative}}" data-type="{{eventType}}">{{title}}<span>{{type}}</span></li>',
            lastItemTemplate: `<li class="autocomplete-item" data-url="" data-type="">${seeAllText} "{{title}}"</li>`,
            onSelect: (selectedElement) => {
              const $selectedElement = $(selectedElement);
              let url = stripTags($selectedElement.data('url'));
              let urlAlternative = stripTags($selectedElement.data('url-alternative'));
              let type = $selectedElement.data('type');

              if ($selectedElement.hasClass('autocomplete-item')) {
                type = stripTags(type);

                let text = $selectedElement
                  .html()
                  .replace(/<span>(.*)<\/span>/g, '')
                  .replace('amp;', '');
                text = stripTags(text);

                if (url) {
                  url = appendCurrentDomainPrefix(url);
                  if (urlAlternative) {
                    urlAlternative = appendCurrentDomainPrefix(urlAlternative);
                  }

                  sendGoogleEvent(
                    'Header Search',
                    `Select ${ucfirst(type.toLowerCase())}`,
                    `Success - ${text}`,
                    { ampEventName: 'on_site_search_completed' },
                  );

                  const $searchResults = $selectedElement
                    .closest('.autocomplete-list')
                    .find('.autocomplete-item:not([data-url=""])');
                  const searchResultsCount = $searchResults.length;
                  const selectedIndex = $searchResults.index($selectedElement) + 1;

                  sendGoogleEvent(
                    'Header Search',
                    'Selected Position',
                    `${selectedIndex}/${searchResultsCount}`,
                    {
                      nonInteraction: true,
                    },
                  );

                  window.location.href = urlAlternative || url;
                } else {
                  const searchTerm = $searchInput.val();

                  searchRedirectToResultsPage();

                  sendGoogleEvent(
                    'Header Search',
                    'Select All Results',
                    `Success - ${searchTerm}`,
                    {
                      ampEventName: 'on_site_search_completed',
                    },
                  );
                }
              }
            },
          })
          .on('receivedata', (event, tinyAutocomplete, json) => {
            const tinyAutocompleteData = searchParseResults(
              json,
              tinyAutocomplete.lastSearch,
            );

                tinyAutocomplete.json = tinyAutocompleteData; // eslint-disable-line
                tinyAutocomplete.selectedItem = 0; // eslint-disable-line
          })
          .on('keydown', (event) => {
            const code = event.keyCode ? event.keyCode : event.which;
            const $list = $('header .autocomplete-list').last();
            const index = $list.find('.autocomplete-item.active').index();
            if (code === 13) {
              if (
                $list
                      && $list.css('display') !== 'none'
                      && $list.find('li').length > 0
              ) {
                if (index === -1) {
                  const $selectedElement = $list.find(
                    '.autocomplete-item:first-child',
                  );
                  let text = $selectedElement
                    .html()
                    .replace(/<span>(.*)<\/span>/g, '')
                    .replace('amp;', '');
                  text = stripTags(text);

                  $selectedElement.click();

                  sendGoogleEvent('Header Search', 'Enter', text);
                }
              } else {
                const text = $searchInput.val();

                searchRedirectToResultsPage(text);
              }
            } else if (code === 27) {
              $searchInput.val('').removeClass('focus');
              $('html, body').removeClass('search-focused');
            }
          });
      });
    })
    .on('blur', () => {
      $('html, body').removeClass('search-focused');
    });

  travellerEnquiryStore.initialize();
};

let topBannerInitiated = false;

export const topBannerShow = () => {
  if (!topBannerInitiated) {
    topBannerInitiated = true;

    sendRequest('/api/common/component/top_banner', {}, (data) => {
      $('body').trigger('banner:init');
      $('.t_b').addClass('done').html(data.component);

      const bannerType = $('body').data('b');

      /* Initiate Banner for Homepage */
      const $mainTop = $('main .top');
      if ($mainTop.find('.sch').length) {
        if (
          bannerType === 'you_reffered_not_logged'
            && $('#row-banner.for_referred').length > 0
        ) {
          $('main .top').append(
            // eslint-disable-next-line no-useless-concat
            `${'<div class="yrnl">' + '<div><span>'}${$('#row-banner').data(
              'in',
            )}</span>`
              + '<br>sent you a 5% discount</div>'
              + '<span class="li">Redeem discount</span>'
              + '</div>',
          );

          $('#row-banner .inv_image').clone().prependTo('main .top .yrnl');

          $mainTop.find('.yrnl').click(() => {
            window.location.href = $('#row-banner a').attr('href');
          });
        }
      }
    });
  }
};

export const topBannerInitiate = () => {
  if ($('.t_b').length > 0) {
    topBannerShow();
  }
};

let newsletterTopBannerInitiated = false;
const newsletterTopBannerMaxWindowWidth = 963;

export const newsletterTopBannerCheck = () => {
  if (newsletterTopBannerInitiated) {
    const $fixedBlock = $('.b.val.fixed');
    if ($fixedBlock.length > 0) {
      $fixedBlock.addClass('wtop');
    } else {
      $fixedBlock.removeClass('wtop');
    }

    const $fixedMenu = $('.b.menu ul.fixed');
    if ($fixedMenu.length > 0) {
      $fixedMenu.addClass('wtop');
    } else {
      $fixedMenu.removeClass('wtop');
    }

    if (!$('#tnb').length) {
      $fixedBlock.removeClass('wtop');
      $fixedMenu.removeClass('wtop');
    }
  }
};

export const newsletterTopBannerAllChecks = () => !$('body').data('r')
&& !$('.r2 ul li.tr').hasClass('logged')
&& !getCookie('tnbcls')
&& $('#row-banner').length === 0
&& !$('body').hasClass('tab')
&& $(window).width() >= newsletterTopBannerMaxWindowWidth;

export const newsletterTopBannerShow = () => {
  if (!newsletterTopBannerInitiated) {
    newsletterTopBannerInitiated = true;

    sendRequest('/api/subscribe/signup', {}, (data) => {
      if (data.status === 'OK') {
        $('body').prepend(data.html);

        const tnb = '#tnb .tnb1 .in';
        const placeholder = $(`${tnb} input`).attr('placeholder');

        $(`${tnb} div`).click((event) => {
          const email = $.trim($(`${tnb} input`).val());
          if (!email || !checkString(email, 'email')) {
            $(`${tnb} input`)
              .addClass('red')
              .attr('placeholder', 'Please, enter a valid email')
              .val('')
              .focus(() => {
                $(event.currentTarget)
                  .removeClass('red')
                  .attr('placeholder', placeholder)
                  .val(email);
              });
            return false;
          }

          sendRequest(
            '/api/subscribe/check',
            { email },
            (requestData) => {
              if (requestData.status === 'OK') {
                $(tnb).html(
                  '<b>Thanks! You will receive an email soon</b>',
                );

                setCookie({
                  name: 'tnbcls',
                  value: '1',
                  expires: 365 * 24 * 3600,
                  path: '/',
                });
              }
            },
          );

          return true;
        });

        $(`${tnb} input`).live('keyup', (event) => {
          const code = event.keyCode ? event.keyCode : event.which;
          if (code === 13) {
            $(`${tnb} div`).click();
          }
        });

        $('#tnb .tnb1 .cls').click(() => {
          $('#tnb').remove();
          // name, value, expires, path, domain, secure
          setCookie({
            name: 'tnbcls',
            value: '1',
            expires: 365 * 24 * 3600,
            path: '/',
          });

          newsletterTopBannerCheck();
        });

        newsletterTopBannerCheck();
      }
    });
  } else {
    newsletterTopBannerCheck();
  }
};

export const newsletterTopBannerInitiate = () => {
  if (newsletterTopBannerAllChecks()) {
    newsletterTopBannerShow();
  }

  $(window).bind('resize', () => {
    if (newsletterTopBannerAllChecks()) {
      newsletterTopBannerShow();
    } else {
      newsletterTopBannerCheck();
    }
  });
};

export const trustBannerInitiate = () => {
  let timeout = false;
  let hasInitialLoadBeenObserved = false;
  const trustBannerSelector = '.js-display-trust-banner';
  const trustBannerWrapperSelector = `${trustBannerSelector} .js-scout-component-top-banner__wrapper`;
  const numberOfSlides = document.querySelector(trustBannerWrapperSelector)
    ? document.querySelector(trustBannerWrapperSelector).dataset?.numberOfSlides
    : 3;
  const topBannersSelector = '.js-display-top-banners';
  const asyncDisplaySelector = `.scout-component-top-banner__blocks-${numberOfSlides}`;
  const hideAfterMs = $(trustBannerSelector)
    .data('hide-after');

  const loadSVG = (targetElement) => {
    const supportElem = $(targetElement)
      .find('.ao-banners-trust-support__icon')[0];
    const noFeesElem = $(targetElement)
      .find('.ao-banners-trust-support__icon-fees')[0];
    const trustpilotElem = $(targetElement)
      .find('.ao-banners-trust-trustpilot__logo')[0];

    if (supportElem) {
      $(supportElem)
        .css('background-image', "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23505557' fill-rule='evenodd' d='M6.375 5.75A1.125 1.125 0 005.25 6.875v7.5A1.125 1.125 0 006.375 15.5H8.25a.75.75 0 01.75.75v2.349l4.459-2.973a.75.75 0 01.416-.126h3.75a1.125 1.125 0 001.125-1.125v-7.5a1.125 1.125 0 00-1.125-1.125zm-1.856-.731a2.63 2.63 0 011.856-.769h11.25a2.625 2.625 0 012.625 2.625v7.5A2.625 2.625 0 0117.625 17h-3.523l-5.436 3.624A.75.75 0 017.5 20v-3H6.375a2.625 2.625 0 01-2.625-2.625v-7.5c0-.696.277-1.364.769-1.856M7.25 9A.75.75 0 018 8.25h8a.75.75 0 010 1.5H8A.75.75 0 017.25 9M8 11.75a.75.75 0 000 1.5h8a.75.75 0 000-1.5z' clip-rule='evenodd'/%3E%3C/svg%3E\")");
    }

    if (noFeesElem) {
      $(noFeesElem)
        .css('background-image', "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Cpath fill='%23505557' fill-rule='evenodd' d='M2.821 2.821A1.95 1.95 0 014.2 2.25h13.2a1.95 1.95 0 011.95 1.95V9a.75.75 0 01-1.5 0V7.35H3.75v6.45a.45.45 0 00.45.45H9a.75.75 0 010 1.5H4.2a1.95 1.95 0 01-1.95-1.95V4.2c0-.517.205-1.013.571-1.379m.929 3.03h14.1V4.2a.45.45 0 00-.45-.45H4.2a.45.45 0 00-.45.45zm8.4 10.349a4.05 4.05 0 016.334-3.345l-5.629 5.628a4.03 4.03 0 01-.705-2.283m1.766 3.344a4.05 4.05 0 005.63-5.629zM16.2 10.65a5.55 5.55 0 100 11.1 5.55 5.55 0 000-11.1M4.65 9.6a.75.75 0 01.75-.75h4.8a.75.75 0 010 1.5H5.4a.75.75 0 01-.75-.75m.75 1.65a.75.75 0 000 1.5h2.4a.75.75 0 000-1.5z' clip-rule='evenodd'/%3E%3C/svg%3E\")");
    }

    if (trustpilotElem) {
      $(trustpilotElem)
        .css('background-image', "url(\"data:image/svg+xml;charset=utf-8,%3Csvg viewBox='20.5 248.5 600 147.3' width='250' height='auto' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M178.2 300.7h60.7V312H215v63.7h-13.1V312h-23.8zm58.1 20.7h11.2v10.5h.2c.4-1.5 1.1-2.9 2.1-4.3s2.2-2.7 3.7-3.8c1.4-1.2 3-2.1 4.8-2.8 1.7-.7 3.5-1.1 5.3-1.1 1.4 0 2.4.1 2.9.1.5.1 1.1.2 1.6.2v11.5c-.8-.2-1.7-.3-2.6-.4s-1.7-.2-2.6-.2c-2 0-3.9.4-5.7 1.2s-3.3 2-4.7 3.5c-1.3 1.6-2.4 3.5-3.2 5.8s-1.2 5-1.2 8v25.8h-12zm86.8 54.3h-11.8v-7.6h-.2c-1.5 2.8-3.7 4.9-6.6 6.6s-5.9 2.5-8.9 2.5c-7.1 0-12.3-1.7-15.5-5.3-3.2-3.5-4.8-8.9-4.8-16v-34.5h12v33.3c0 4.8.9 8.2 2.8 10.1 1.8 2 4.4 3 7.7 3 2.5 0 4.6-.4 6.3-1.2s3.1-1.8 4.1-3.1c1.1-1.3 1.8-2.9 2.3-4.7s.7-3.8.7-5.9v-31.5h12v54.3zm20.4-17.4c.4 3.5 1.7 5.9 4 7.4 2.3 1.4 5.1 2.1 8.3 2.1 1.1 0 2.4-.1 3.8-.3s2.8-.5 4-1c1.3-.5 2.3-1.2 3.1-2.2s1.2-2.2 1.1-3.7-.6-2.8-1.7-3.8-2.4-1.7-4-2.4c-1.6-.6-3.5-1.1-5.6-1.5s-4.2-.9-6.4-1.4-4.4-1.1-6.5-1.8-3.9-1.6-5.6-2.9c-1.6-1.2-3-2.7-3.9-4.6-1-1.9-1.5-4.1-1.5-6.9 0-3 .7-5.4 2.2-7.4 1.4-2 3.3-3.6 5.5-4.8s4.7-2.1 7.4-2.6 5.3-.7 7.7-.7c2.8 0 5.5.3 8 .9s4.9 1.5 6.9 2.9c2.1 1.3 3.8 3.1 5.1 5.2 1.4 2.1 2.2 4.7 2.6 7.7h-12.5c-.6-2.9-1.9-4.8-3.9-5.8-2.1-1-4.4-1.5-7.1-1.5-.8 0-1.9.1-3 .2-1.2.2-2.2.4-3.3.8-1 .4-1.9 1-2.6 1.7s-1.1 1.7-1.1 2.9c0 1.5.5 2.6 1.5 3.5s2.3 1.6 4 2.3c1.6.6 3.5 1.1 5.6 1.5s4.3.9 6.5 1.4 4.3 1.1 6.4 1.8 4 1.6 5.6 2.9c1.6 1.2 3 2.7 4 4.5s1.5 4.1 1.5 6.7c0 3.2-.7 5.9-2.2 8.2-1.5 2.2-3.4 4.1-5.7 5.5s-5 2.4-7.8 3.1c-2.9.6-5.7 1-8.5 1-3.4 0-6.6-.4-9.5-1.2s-5.5-2-7.6-3.5c-2.1-1.6-3.8-3.5-5-5.9-1.2-2.3-1.9-5.1-2-8.4h12.1v.1zm39.5-36.9h9.1V305h12v16.3h10.8v8.9h-10.8v29c0 1.3.1 2.3.2 3.3.1.9.4 1.7.7 2.3.4.6 1 1.1 1.7 1.4.8.3 1.8.5 3.2.5.8 0 1.7 0 2.5-.1s1.7-.2 2.5-.4v9.3c-1.3.2-2.6.3-3.9.4-1.3.2-2.5.2-3.9.2-3.2 0-5.7-.3-7.6-.9s-3.4-1.5-4.5-2.6c-1.1-1.2-1.8-2.6-2.2-4.3s-.6-3.8-.7-6v-32H383v-9.1zm40.3 0h11.3v7.4h.2c1.7-3.2 4-5.4 7-6.8s6.2-2.1 9.8-2.1c4.3 0 8 .7 11.2 2.3 3.2 1.5 5.8 3.5 7.9 6.2 2.1 2.6 3.7 5.7 4.7 9.2s1.6 7.3 1.6 11.2c0 3.7-.5 7.2-1.4 10.6-1 3.4-2.4 6.5-4.3 9.1s-4.3 4.7-7.3 6.3-6.4 2.4-10.4 2.4c-1.7 0-3.5-.2-5.2-.5s-3.4-.8-5-1.5-3.1-1.6-4.4-2.7c-1.4-1.1-2.5-2.4-3.4-3.8h-.2v27.1h-12v-74.4zm41.9 27.2c0-2.4-.3-4.8-1-7.1-.6-2.3-1.6-4.3-2.9-6.1s-2.9-3.2-4.7-4.3c-1.9-1.1-4.1-1.6-6.5-1.6-5 0-8.8 1.7-11.4 5.2-2.5 3.5-3.8 8.2-3.8 14 0 2.8.3 5.3 1 7.6s1.6 4.3 3 6c1.3 1.7 2.9 3 4.8 4s4 1.5 6.5 1.5c2.8 0 5-.6 6.9-1.7s3.4-2.6 4.7-4.3c1.2-1.8 2.1-3.8 2.6-6.1.5-2.4.8-4.7.8-7.1zm21.1-47.9h12V312h-12zm0 20.7h12v54.3h-12zm22.7-20.7h12v75h-12zm48.6 76.5c-4.3 0-8.2-.7-11.6-2.2s-6.2-3.4-8.6-5.9c-2.3-2.5-4.1-5.6-5.3-9.1s-1.9-7.4-1.9-11.5.6-7.9 1.9-11.4c1.2-3.5 3-6.5 5.3-9.1 2.3-2.5 5.2-4.5 8.6-5.9s7.3-2.2 11.6-2.2 8.2.7 11.6 2.2c3.4 1.4 6.2 3.4 8.6 5.9 2.3 2.5 4.1 5.6 5.3 9.1s1.9 7.3 1.9 11.4c0 4.2-.6 8-1.9 11.5s-3 6.5-5.3 9.1c-2.3 2.5-5.2 4.5-8.6 5.9s-7.2 2.2-11.6 2.2zm0-9.5c2.6 0 5-.6 6.9-1.7 2-1.1 3.5-2.6 4.8-4.4s2.2-3.9 2.8-6.1c.6-2.3.9-4.6.9-7 0-2.3-.3-4.6-.9-6.9s-1.5-4.3-2.8-6.1-2.9-3.2-4.8-4.3c-2-1.1-4.3-1.7-6.9-1.7s-5 .6-6.9 1.7c-2 1.1-3.5 2.6-4.8 4.3-1.3 1.8-2.2 3.8-2.8 6.1s-.9 4.6-.9 6.9c0 2.4.3 4.7.9 7s1.5 4.3 2.8 6.1 2.9 3.3 4.8 4.4c2 1.2 4.3 1.7 6.9 1.7zm31-46.3h9.1V305h12v16.3h10.8v8.9h-10.8v29c0 1.3.1 2.3.2 3.3.1.9.4 1.7.7 2.3.4.6 1 1.1 1.7 1.4.8.3 1.8.5 3.2.5.8 0 1.7 0 2.5-.1s1.7-.2 2.5-.4v9.3c-1.3.2-2.6.3-3.9.4-1.3.2-2.5.2-3.9.2-3.2 0-5.7-.3-7.6-.9s-3.4-1.5-4.5-2.6c-1.1-1.2-1.8-2.6-2.2-4.3s-.6-3.8-.7-6v-32h-9.1v-9.1z'/%3E%3Cpath d='M164.2 300.7h-54.9l-16.9-52.2-17 52.2-54.9-.1 44.4 32.3-17 52.2 44.4-32.3 44.4 32.3-16.9-52.2z' fill='%2300b67a'/%3E%3Cpath d='M123.6 344.7l-3.8-11.8-27.4 19.9z' fill='%23005128'/%3E%3C/svg%3E\")");
    }
  };

  const showSalesBanner = (targetElement) => {
    const currentLanguage = $('html').attr('lang');
    const lastElem = currentLanguage === 'en'
      ? $(targetElement).find('.ao-banners-trust-support__icon')[0]
      : $(targetElement).find('.ao-banners-trust-trustpilot__logo')[0];

    if (lastElem) {
      if (hasInitialLoadBeenObserved) {
        $(trustBannerSelector).addClass('hid');
        $(topBannersSelector).removeClass('hid');
      } else {
        hasInitialLoadBeenObserved = true;
      }
    }
  };

  const configTrustBanner = () => {
    const $bannerWrapper = $('.scout-component-top-banner')[0];
    const isMobile = $bannerWrapper && getComputedStyle($bannerWrapper)
      .getPropertyValue('--mobile-device') === '1';

    if (isMobile) {
      setIntersectionObserver({
        selector: asyncDisplaySelector,
        callback: loadSVG,
        exitCallback: hideAfterMs > 0 ? showSalesBanner : null,
      });
    } else if (hideAfterMs > 0) {
      if (timeout) clearTimeout(timeout);

      timeout = setTimeout(() => {
        $(trustBannerSelector).addClass('hid');
        $(topBannersSelector).removeClass('hid');
      }, hideAfterMs);
    }
  };

  configTrustBanner();
  $(window).on('resize', configTrustBanner);
};

const upsEventActions = {
  'best-selection': 'best selection',
  'best-prices': 'best prices',
  deposit: 'deposit',
};
export const upsInitiate = () => {
  $('.js-ups-link').click((e) => {
    sendGoogleEvent(
      'header USP',
      upsEventActions[e.target.dataset.route],
    parameters.page_type || location.pathname.split("/")[1] // eslint-disable-line
    );
  });
};

export const heartIconInitiate = () => {
  $('.js-wishlist-tours').click(() => {
    sendGoogleEvent(
      'Header Saved Tours',
      'Click',
        parameters.page_type || location.pathname.split("/")[1] // eslint-disable-line
    );
  });
};

export const profileWishllstInitiate = () => {
  $('.profile-wishlist-js').click(() => {
    sendGoogleEvent(
      'Header Saved Tours',
      'Click',
        parameters.page_type || location.pathname.split("/")[1] // eslint-disable-line
    );
  });
};
